import type { ChauffeurPage } from "../slug-chauffeur";

import heroImage from "@/assets/images/chauffeur/aeroport/Transferts-aeroports-heliports.png";

const airport: ChauffeurPage = {
  slug: "airport",
  title: "Airport chauffeur – VTC transfers",
  subtitle: "Pick-up in Cannes, flight tracking and personal welcome.",
  keywords: ["airport chauffeur", "airport VTC", "airport transfer"],
  hero: {
    title: "Airport & heliport transfers",
    subtitle:
      "To/from Cannes: Nice, Monaco, Marseille – name-board welcome & luggage help.",
    keywords: ["flight tracking", "dedicated welcome", "clear flat rates"],
    imageSrc: heroImage.src,
    imageAlt: "Airport & heliport transfers",
    badges: ["Flight tracking", "Name-board welcome", "Flat rates"],
  },
  benefits: {
    heading: "Why choose our airport transfers",
    items: [
      {
        title: "Flight tracking",
        description: "We adjust the pick-up time if your flight is delayed.",
      },
      {
        title: "Name-board welcome",
        description: "Clear meeting point, escort to the vehicle.",
      },
      {
        title: "Flat rates",
        description: "Prices known in advance, no surprises.",
      },
    ],
  },
  services: {
    heading: "Lines & connections",
    services: [
      {
        title: "Nice Airport (NCE)",
        text: "From Cannes: Monaco, Antibes, Saint-Tropez.",
      },
      {
        title: "Marseille Airport (MRS)",
        text: "French Riviera and Provence connections.",
      },
      { title: "Toulon Airport (TLN)", text: "Var & coastline." },
      {
        title: "Milan Malpensa Airport (MXP)",
        text: "Long-distance trips to Lombardy on request.",
      },
      { title: "Monaco Heliport", text: "Fast, discreet connections." },
    ],
  },
  locations: {
    heading: "Points served",
    items: [
      { name: "Nice Airport" },
      { name: "Marseille Provence" },
      { name: "Toulon Hyères" },
      { name: "Monaco Heliport" },
      { name: "Cannes Mandelieu" },
      { name: "Milan Malpensa" },
      { name: "Italian Riviera" },
    ],
  },
  generic: {
    heading: "Arrive in Cannes with peace of mind",
    subheading: "We handle everything: tracking, welcome, guidance.",
    paragraphs: [
      "Your chauffeur tracks your flight, waits at the agreed point and escorts you to the vehicle.",
      "The airport service is built to limit uncertainty: clear meeting point, anticipated delay margin and a route adapted to traffic.",
      "We cover the main regional airports, heliports and extensions on request toward the Italian Riviera and Milan.",
    ],
    bullets: ["Name sign", "Luggage help", "Waiting time included"],
  },
  process: {
    heading: "Airport pick-up in practice",
    steps: [
      "Share your flight details and terminal.",
      "Set up flight tracking and arrival timing.",
      "Personal welcome at the agreed point.",
      "Optimised route to your final destination.",
    ],
  },
  faq: [
    {
      q: "How do you handle an arrival with a major delay?",
      a: "Flight tracking automatically adjusts the pick-up to the real landing time.",
    },
    {
      q: "Can you handle a night or very early morning transfer?",
      a: "Yes, subject to availability, we cover extended hours on the airport lines.",
    },
    {
      q: "Can a long-distance trip be added after the airport?",
      a: "Yes, we can organise long-distance transfers to the Riviera, the Italian Riviera or Milan.",
    },
  ],
  relatedLinks: [
    {
      label: "Private transfer Cannes ⇄ Nice Airport",
      href: "/en/chauffeur/transfers/cannes-nice-airport",
    },
    {
      label: "Private transfer Monaco ⇄ Nice Airport",
      href: "/en/chauffeur/transfers/monaco-nice-airport",
    },
    {
      label: "Private transfer Nice Airport ⇄ Saint-Tropez",
      href: "/en/chauffeur/transfers/nice-airport-saint-tropez",
    },
    {
      label: "Private transfer Nice Airport ⇄ Saint-Jean-Cap-Ferrat",
      href: "/en/chauffeur/transfers/nice-airport-saint-jean-cap-ferrat",
    },
    {
      label: "Our chauffeur transfers",
      href: "/en/chauffeur/transfers",
    },
    {
      label: "Private driver on the French Riviera",
      href: "/en/chauffeur/french-riviera",
    },
    { label: "Make a booking request", href: "/en/reservation" },
  ],
  cta: {
    title: "Book your airport transfer",
    text: "Confirm your arrival in Cannes in seconds.",
    primaryHref: "/en/reservation",
    primaryLabel: "Book",
  },

  seo: {
    title: "Nice Airport Chauffeur — Cannes from 100 €",
    description:
      "Private transfer from Nice airport: Cannes from 100 €, Monaco 150 €, Saint-Tropez 300 €. Flight tracking, name-board welcome, fixed price on the quote.",
    canonical: "/en/chauffeur/airport",
  },
};

export default airport;
